import { Component } from "@angular/core";

@Component({
  selector: "app-impact",
  templateUrl: "./impact.component.html",
  styleUrls: ["./impact.component.scss"],
})
export class ImpactComponent {
  cardsData = [
    {
      title: "Innovative approach ",
      title2: "to educational technology",
      content:
        "VIRSA excels in educational technology through constant R&D investment, strategic partnerships, user-centric design, agile development, integration of emerging tech, and continuous improvement.",
    },
    {
      title: "Empowering educators ",
      title2: "and learners",
      content:
        "VIRSA empowers educators and learners with innovative educational technology solutions tailored to their needs, fostering collaboration, engagement, and personalized learning experiences.",
    },
    {
      title: "Driving positive ",
      title2: "outcomes in education",
      content:
        "VIRSA drives educational success through innovative technology, fostering positive outcomes for both educators and learners.",
    },
  ];
}
